// src/pages/StartNowPage.js
import React, { useState } from 'react';
import '../styles/StartNowPage.css';

const StartNowPage = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    entityType: '',
    state: '',
    businessName: '',
    timeline: '',
    contactMethod: '',
    message: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Here you would typically handle form submission
    // For example, send the data to your backend API
    console.log('Form submitted:', formData);
    // Show success message or redirect
    alert('Thank you! We will contact you within 24 hours to get started.');
  };

  return (
    <div className="start-now-page">
      <section className="start-now-header">
        <div className="container">
          <h1 className="start-now-title">Ready to Form Your Business?</h1>
          <p className="start-now-subtitle">Let's make it official.</p>
          <p className="start-now-description">
            Fill out the form below and we'll take care of the rest. Our team will review your information 
            and contact you within 24 hours to discuss next steps.
          </p>
        </div>
      </section>

      <section className="section form-section">
        <div className="container">
          <div className="intake-form-container">
            <form className="intake-form" onSubmit={handleSubmit}>
              <div className="form-section-header">
                <h2>Your Information</h2>
              </div>
              
              <div className="form-group">
                <label htmlFor="name">Full Name</label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
              </div>
              
              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="email">Email Address</label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                  />
                </div>
                
                <div className="form-group">
                  <label htmlFor="phone">Phone Number</label>
                  <input
                    type="tel"
                    id="phone"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    required
                  />
                </div>
              </div>
              
              <div className="form-section-header">
                <h2>Business Details</h2>
              </div>
              
              <div className="form-group">
                <label htmlFor="entityType">Entity Type</label>
                <select
                  id="entityType"
                  name="entityType"
                  value={formData.entityType}
                  onChange={handleChange}
                  required
                >
                  <option value="">Select an entity type</option>
                  <option value="LLC">Limited Liability Company (LLC)</option>
                  <option value="S-Corp">S-Corporation</option>
                  <option value="C-Corp">C-Corporation</option>
                  <option value="Not Sure">Not Sure (We'll help you decide)</option>
                </select>
              </div>
              
              <div className="form-group">
                <label htmlFor="state">State of Formation</label>
                <select
                  id="state"
                  name="state"
                  value={formData.state}
                  onChange={handleChange}
                  required
                >
                  <option value="">Select a state</option>
                  <option value="AL">Alabama</option>
                  <option value="AK">Alaska</option>
                  <option value="AZ">Arizona</option>
                  {/* Add all 50 states */}
                  <option value="WY">Wyoming</option>
                </select>
              </div>
              
              <div className="form-group">
                <label htmlFor="businessName">Desired Business Name (if known)</label>
                <input
                  type="text"
                  id="businessName"
                  name="businessName"
                  value={formData.businessName}
                  onChange={handleChange}
                  placeholder="If you haven't decided yet, leave this blank"
                />
              </div>
              
              <div className="form-section-header">
                <h2>Additional Information</h2>
              </div>
              
              <div className="form-group">
                <label htmlFor="timeline">When would you like to form your business?</label>
                <select
                  id="timeline"
                  name="timeline"
                  value={formData.timeline}
                  onChange={handleChange}
                  required
                >
                  <option value="">Select a timeline</option>
                  <option value="Immediately">As soon as possible</option>
                  <option value="1-2 weeks">Within 1-2 weeks</option>
                  <option value="1 month">Within a month</option>
                  <option value="Exploring">Just exploring options for now</option>
                </select>
              </div>
              
              <div className="form-group">
                <label htmlFor="contactMethod">Preferred Contact Method</label>
                <select
                  id="contactMethod"
                  name="contactMethod"
                  value={formData.contactMethod}
                  onChange={handleChange}
                  required
                >
                  <option value="">Select contact method</option>
                  <option value="Email">Email</option>
                  <option value="Phone">Phone</option>
                  <option value="Text">Text Message</option>
                </select>
              </div>
              
              <div className="form-group">
                <label htmlFor="message">Additional Comments or Questions</label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  rows="4"
                  placeholder="Tell us anything else that might help us prepare for our conversation"
                ></textarea>
              </div>
              
              <div className="form-submit">
                <button type="submit" className="btn btn-primary btn-lg">Submit</button>
              </div>
            </form>
          </div>
          
          <div className="next-steps">
            <h3>What Happens Next</h3>
            <ol className="steps-list">
              <li>
                <div className="step-number">1</div>
                <div className="step-content">
                  <h4>Review Your Information</h4>
                  <p>Our team will review your submission within 24 hours.</p>
                </div>
              </li>
              <li>
                <div className="step-number">2</div>
                <div className="step-content">
                  <h4>Initial Consultation</h4>
                  <p>We'll contact you to discuss your specific business needs and answer your questions.</p>
                </div>
              </li>
              <li>
                <div className="step-number">3</div>
                <div className="step-content">
                  <h4>Formation Process</h4>
                  <p>We'll prepare all necessary documents and guide you through the formation process.</p>
                </div>
              </li>
              <li>
                <div className="step-number">4</div>
                <div className="step-content">
                  <h4>Launch Your Business</h4>
                  <p>We'll provide ongoing support as you begin operating your new business.</p>
                </div>
              </li>
            </ol>
          </div>
          
          <div className="trust-badges">
            <div className="trust-badge">
              <i className="fas fa-shield-alt"></i>
              <span>100+ successful formations</span>
            </div>
            <div className="trust-badge">
              <i className="fas fa-check-circle"></i>
              <span>5-star client satisfaction</span>
            </div>
            <div className="trust-badge">
              <i className="fas fa-lock"></i>
              <span>Secure & confidential</span>
            </div>
          </div>
        </div>
      </section>

      <section className="section help-section">
        <div className="container">
          <div className="help-content">
            <h2>Need Help or Have Questions?</h2>
            <p>Our team is available to assist you through every step of the process.</p>
            <div className="contact-options">
              <div className="contact-option">
                <i className="fas fa-phone-alt"></i>
                <span>(253) 802-4804</span>
              </div>
              <div className="contact-option">
                <i className="fas fa-envelope"></i>
                <span>legate@legatebusiness.com</span>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default StartNowPage;
